var map = {
	"./poly-1.png": "895a",
	"./poly-10.png": "c1d4",
	"./poly-2.png": "635e",
	"./poly-3.png": "e61d",
	"./poly-4.png": "1751",
	"./poly-5.png": "398b",
	"./poly-6.png": "32c4",
	"./poly-7.png": "44b6",
	"./poly-8.png": "9bef",
	"./poly-9.png": "64ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5249";